import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ShoppingBag.svg",
  "use": "ShoppingBag.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"ShoppingBag.svg\"><path d=\"M50,51.7728a2.0012,2.0012,0,0,1-1.9855,2.248H15.9973a2,2,0,0,1-1.9855-2.248h0a127.4623,127.4623,0,0,0,.9849-15.8151V26.0208a2.0007,2.0007,0,0,1,2.0012-2h4.0229v-5a11,11,0,1,1,22,0v5h3.9935a2.0006,2.0006,0,0,1,2.0011,2v9.9368A127.4623,127.4623,0,0,0,50,51.7727Zm-10.98-32.7519a7,7,0,1,0-14,0v5h14Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol